import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Inject,
  Input,
  Optional,
  Output,
  TemplateRef
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SidepanelComponent } from '../sidepanel';

@UntilDestroy()
@Component({
  selector: 'app-sidepanel-header',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidepanelHeaderComponent {
  @Input() name = '';
  @Input() subtitle: string | undefined = undefined;
  @Input() subtitleTooltip: string | undefined = undefined;
  @Input() time: number = undefined;
  @Input() iconType: 'avatar' | 'none' | (string & {}) = 'none';
  @Input() tooltip: string | undefined = undefined;
  @Input() showAiGeneratedBadge = false;
  @Input() showCloseButton = true;

  @ContentChild('rightSide') rightSideTemplate?: TemplateRef<any>;

  @Output() closed = new EventEmitter<void>();

  constructor(@Inject(SidepanelComponent) @Optional() private sidepanel: SidepanelComponent) { }

  close() {
    if (this.closed.observed) this.closed.emit();
    else this.sidepanel?.close();
  }
}
